const useCapitalize = () => {
  function capitalize(str: string) {
    if (!str) return "";

    return str
      .split(" ")
      .map(
        (word) =>
          word.charAt(0).toLocaleUpperCase("tr") +
          word.slice(1).toLocaleLowerCase("tr")
      )
      .join(" ");
  }

  return { capitalize };
};

export default useCapitalize;
